import { Component, OnInit, Input } from '@angular/core';
import { NgbTooltip, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-pg-map-link',
    templateUrl: './pg-map-link.component.html',
    styleUrls: ['./pg-map-link.component.scss'],
    standalone: false
})
export class PgMapLinkComponent implements OnInit {

    @Input() coordinates:string;
    @Input() address:string;

    @Input() disabled:boolean;
    @Input() tooltipContainer:any;

    constructor(private tooltipConfig: NgbTooltipConfig) { }

    ngOnInit() {
        if(typeof this.tooltipContainer == 'undefined') {
            this.tooltipContainer = this.tooltipConfig.container;
        }
    }

    encodeURIComponent(val:string) {
        return encodeURIComponent(val)
    }

    private _closeTimeout = null;

    closeWithDelay(t:NgbTooltip) {
        if(this._closeTimeout != null) clearTimeout(this._closeTimeout);

        this._closeTimeout = setTimeout(() => {
            this._closeTimeout = null;
            t.close();
        }, 500000)
    }

    keepOpen(t:NgbTooltip) {
        if(!this.disabled) {
            if(this._closeTimeout != null) clearTimeout(this._closeTimeout);

            if(!t.isOpen()) {
                t.open();
            }
        }
    }

    stopEvent(event:MouseEvent) {
        event.stopPropagation()
    }
}
